import { createAction, props } from '@ngrx/store';
import {
  IMapMatrixResponse,
  IMapUnlockLandResponse,
} from 'src/app/api/interfaces/global-map.interface';

export const setInitialMapData = createAction(
  '[Auth API] set initial matrix Success',
  props<{ responseData: IMapMatrixResponse[] }>()
);
export const updateLandData = createAction(
  '[Auth API] update land Success',
  props<{ responseData: IMapUnlockLandResponse }>()
);
export const updateMapData = createAction(
  '[Auth API] update matrix Success',
  props<{ responseData: IMapMatrixResponse[] }>()
);
